import AdminUpdatePasein from "../../components/AdminTreatmentPlan/TreatmentUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
